const d3 = require('d3');

d3.select('body').append('div').attr('id', 'toolTip');

const makePieChart = function (elementId, data, {
	onClick,
	chartMethod = {},
	width = 400,
	height = 200,
	outerRadius = (width / 4),
	innerRadius = 0,
	chartColor = 'currentColor',
	legendColor = 'currentColor',
	uniqKey = 'type',
	valueKey,
	mouseAxisHover = item => `${item.toLocaleString()}`, // a format specifier string for the rect label
	legendText = () => {
	},
}) {

	function removeChart() {
		d3.select(`#${elementId} svg`).remove();
	}

	removeChart();

	if (!(elementId in chartMethod)) {
		chartMethod[elementId] = {};
	}

	let selectedItem;
	const click = function (d, i) {
		if (!onClick) return
		const type = i?.data?.type || i?.type || '';
		const cleanFilter = (selectedItem === type);
		legendGroup.selectAll('.item').style('opacity', 0.5);
		pieGroup.selectAll('.original').style('opacity', 0.5);
		legendGroup.selectAll(`.item.${type}`).style('opacity', 1);
		pieGroup.selectAll(`.original.${type}`).style('opacity', 1);
		onClick?.(type, cleanFilter);
		if (!cleanFilter) {
			chartMethod[elementId]?.removeHighlight()
			selectedItem = type;
			return;
		}
		selectedItem = null;
	};

	const path = d3.arc()
		.outerRadius(outerRadius)
		.innerRadius(innerRadius)

	const svg = d3.select(`#${elementId}`)
		.append('svg')
		.attr('width', width)
		.attr('height', height)
		.attr('viewBox', [0, 0, width, height])
		.attr('style', 'max-width: 100%; height: auto; height: intrinsic;font-size:11px;');

	const pie = d3.pie()
		.sort(null)
		.value(valueKey);

	const pieData = pie(data)
	const pieGroup = svg.append('g').attr('class', 'chart').attr('transform', `translate(${outerRadius},${outerRadius})`);

	const arc = pieGroup.selectAll('.arc')
		.data(pieData)
		.enter().append('g')
		.attr('class', 'arc');
	arc.append('path')
		.attr('d', path)
		.attr('class', (d) => `original ${d.data?.[uniqKey] || ''}`)
		.style('opacity', 1)
		.attr('fill', chartColor)
		.on('click', click)
		.on('mouseover', (d, i) => {
			d3.select('#toolTip')
				.style('left', `${d.pageX}px`)
				.style('top', `${d.pageY}px`)
				.style('opacity', 1)
				.style('position', 'absolute')
				.style('background-color', '#404040')
				.style('color', 'white')
				.style('border-radius', '8px')
				.style('padding', '4px 8px')
				.style('font-size', '14px')
				.text(() => mouseAxisHover(i?.data));
		})
		.on('mouseout', () => {
			d3.select('#toolTip')
				.style('opacity', 0);
		});
	const foreign = svg.append('foreignObject')
		.attr('width', width / 2)
		.attr('height', height)
		.attr('transform', `translate(${width / 2},${0})`)
		.append('xhtml:div')
		.style('max-height', `${height}px`)
		.style('overflow-y', 'auto')
		.style('overflow-x', 'hidden')
		.style('direction', 'ltr');

	const legendHeight = data.length * 20;
	const legendSvg = foreign.append('svg')
		.attr('width', width / 2)
		.attr('height', legendHeight)
		.attr('viewBox', [0, 0, width / 2, legendHeight])

	let legendGroup = legendSvg.append('g').attr('class', 'legend').attr('transform', 'translate(-15,0)')

	legendGroup.selectAll('g.items').data(data)
		.enter()
		.append('g')
		.style('direction', 'ltr')
		.attr('class', (d) => `item ${d?.[uniqKey] || ''}`)
		.on('click', click)
		.attr('transform', (d, i) => `translate(180, ${i * 20})`)
		.each(function (d, i) {
			const g = d3.select(this)
			const rectSize = 15
			g.append('rect').attr('width', rectSize).attr('height', rectSize).attr('fill', () => legendColor(d.data, i))
			g.append('text')
				.text(() => legendText(d))
				.attr('text-anchor', 'end')
				.style('font-size', 12)
				.attr('dx', -5)
				.attr('dy', 14)
		})


	chartMethod[elementId].removeChart = removeChart;
	chartMethod[elementId].addHighlight = function (data, type) {
		// pieGroup.selectAll(`.highlighted`).remove();
		// pieGroup.selectAll(`.original`).style('opacity', 1)
		pieGroup.selectAll('.original').style('opacity', 0.5);

		const highlightedPath = d3.arc()
			.outerRadius((d, i) => {
				const item = data.find(item => item.type == d.data.type)
				return item?.percent || 0
			})
			.innerRadius(0)
		pieGroup.selectAll('.arc').append('path')
			.attr('d', highlightedPath)
			.attr('class', (d) => `highlighted ${d.data?.type || ''}`)
			.style('opacity', 1)
			.attr('fill', chartColor)
	}

	chartMethod[elementId].resetHighlight = function () {
		chartMethod[elementId]?.removeHighlight();
		legendGroup.selectAll('.item').style('opacity', 1);
		pieGroup.selectAll('.original').style('opacity', 1);
	}

	chartMethod[elementId].removeHighlight = function () {
		selectedItem = null;
		pieGroup.selectAll('.highlighted').remove();
	}

	return svg
}

export default makePieChart;
